import React from 'react'
import { useTheme } from '@mui/material/styles'
import logoImageLight from './images/logo_white.png'
import logoImageDark from './images/logo_deep_navy.png'

export const Logo = (props) => {
  const theme = useTheme()
  return (
    <img
      src={theme.palette.mode !== 'dark' ? logoImageDark : logoImageLight}
      alt="Logo"
      width={205} // Update
      height={30} // Update
      // style={{
      //   filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
      // }}
      {...props}
    />
  )
}
